import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import ColorDetail from "./color-detail";

const ColorDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/colors');
    }

    return (
        <ColorDetail id={id} onClose={onClose}/>
    )

});

export default ColorDetailPage;